import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSnackBar, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { DialogBoxComponent } from '../../common/components/dialog-box/dialog-box.component';
import { SpinnerService } from '../../common/components/spinner/overlay-spinner.service';
import { CommonDispatcher } from '../../store/common/common-dispatcher';
import { ViewASIControl } from '../common/presenter/view-asi.presenter';
import { ViewPackageControl } from '../common/presenter/view-package.presenter';
import { ConfirmationBarComponent } from '../confirmation-bar/confirmation-bar.component';
import { ApiHandlerService } from '../services/api-handler/api-handler.service';
import { GenerationComponent } from '../generation/generation.component';
import { MatButton } from '@angular/material/button';
import { NgIf, NgFor } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatPrefix } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort as MatSort_1, MatSortHeader } from '@angular/material/sort';
import { MatCheckbox } from '@angular/material/checkbox';
import { ProductOptionsComponent } from '../product-options/product-options.component';
import { MatPaginator as MatPaginator_1 } from '@angular/material/paginator';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-asi-product-map',
    templateUrl: './asi-product-map.component.html',
    styleUrls: ['./asi-product-map.component.scss'],
    imports: [GenerationComponent, MatButton, NgIf, MatCard, MatIcon, MatPrefix, MatInput, MatTable, MatSort_1, NgFor, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatCheckbox, ProductOptionsComponent, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator_1, TranslatePipe]
})
/**
* Fetches submitted asi and maps (submit request) to submitted products
*/
export class AsiProductMapComponent implements OnInit {
  /**
  * @arg generation the selected generation
  */
  public generation: string;
  /**
* @arg  asiControl model for viewing the asi capabilities
*/
  public asiControl: ViewASIControl;
  /**
  * @arg packageControl model for view packages
  */
  public packageControl: ViewPackageControl;
  /**
  * @arg products to store the get approved products
  */
  public products;
  /**
   * @arg displayedColumns holds the list of headers for capabilities data.
   **/
  public displayedColumns: Array<string | number>;
  /**
   * @arg tableDataSource oto store the data required to display table
   **/
  public tableDataSource: any;
  /**
    * @arg selection to store selected asi
    */
  public selection: any;
  /**
   * @arg paginator paginator
   */
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  /**
   * @arg sort sort
   */
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  /**
   * @arg showTable to store the flag to show/hide table
   */
  public showTable: boolean;
  constructor(
    public apiHandler: ApiHandlerService,
    public router: Router,
    public commonDispatcher: CommonDispatcher,
    public dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    public spinner: SpinnerService
  ) { }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
    this.defaults();
  }
  /**
   * @function defaults Default methods
   */
  private defaults(): void {
    this.showTable = false;
    this.selection = { selected: [] };
  }
  /**
   * @function setGeneration det the genration and retrieve corresponding information
   */
  public setGeneration(generation): void {
    this.generation = generation;
    this.getAsi();
    this.getProducts();
  }
  /**
   * @function packageControl submitted products for generation
   */
  private getProducts(): void {
    this.packageControl = new ViewPackageControl('svppv2');
    this.getRecords(this.packageControl, 'products', 'approved');
  }
  /**
   * @function getAsi get submitted
   */
  private getAsi(): void {
    this.asiControl = new ViewASIControl('svppv2', 'asi-product-map');
    this.getRecords(this.asiControl, 'asi', 'submitted');
  }
  /**
   * @function getRecords gets products and asi
   * @arg control model to get the api info for products or asi
   * @arg requestType asi or products
   * @arg recordType approved or submitted
   */
  private getRecords(control: ViewASIControl | ViewPackageControl, requestType: string, recordType: string): void {
    const spinnerRef = this.spinner.open();
    this.apiHandler.getRequest(control.getApiEndpoint, control.getParams(recordType)).subscribe({
      next: (response) => {
        this.successRecords(response, requestType);
        spinnerRef.close();
      },
      error: (error) => {
        this.showError(error);
        spinnerRef.close();
      }
    }
    );
  }
  /**
   * @function successRecords callback of get Records
   */
  private successRecords(response: object, type: string): void {
    if (type === 'asi' && !!response['payload']) {
      this.asiControl.setData(response['payload'].asiCapabilitiesMappingV2 as Array<object>);
      this.intializeTableData();
    } else if (type === 'products' && !!response['payload']) { this.products = response['payload'].products; }

  }
  /**
  * @method showError displays the error message
  * @arg error error response from the api
  */
  private showError(error: object): void {
    this.defaults();
    if (error['errorCode'] === 'UNAUTHORIZED') {
      this.router.navigate(['dashboard/error'], { queryParams: {}, skipLocationChange: true });
    } else {
      this.commonDispatcher.setErrorCode(error['errorCode']);
      this.dialog.open(DialogBoxComponent, {
        data: {
          type: 'api-error',
          message: error['errorMessage'],
          endPoint: error['api']
        },
        width: '30em', height: 'auto'
      });
    }
  }
  /**
   * @method intializeTableData method will intialize the table data.
   */
  private intializeTableData(): void {
    this.showTable = true;
    this.displayedColumns = this.asiControl.getColumnsProductMap(true);
    this.tableDataSource = new MatTableDataSource(this.asiControl.getTableData());
    this.selection = new SelectionModel<any>(true, []);
    if (this.tableDataSource) {
      this.tableDataSource.paginator = this.paginator;
      this.tableDataSource.sort = this.sort;
    }
  }
  /**
  * @method applyFilter method will take the filterValue and filter over the dataSourse.
  * @param string filterValue anyvalue
  */
  public applyFilter(filterValue: string) {
    this.tableDataSource.filter = filterValue.trim().toLowerCase();
    if (this.tableDataSource.paginator) {
      this.tableDataSource.paginator.firstPage();
    }
  }
  /**
   * @method checkboxChange change method of checkbox - toggle asi element
   */
  public checkboxChange(asiElement: object): void {
    this.selection.toggle(asiElement);
  }
  /**
   * @method getSelectedProducts catch the selected products emitted
   */
  public getSelectedProducts(productIds, asi) {
    this.selection.selected.filter(selectedASI => selectedASI._id === asi._id).map(selectedASI => selectedASI['productIds'] = productIds);
  }
  /**
    * @method createMapping calls approve api to send either the listed capabilities with package ids.
    */
  public createMapping(): void {
    this.apiHandler.postRequest(this.asiControl.getReviewApiEndpoint,
      this.asiControl.mapASIProductsRequest(this.selection.selected),
      this.asiControl.getApiType)
      .subscribe({
      next: () => this.confirmationSnack('review-approve', 'success'),
      error: () => this.errorResponse()
    }
      );
  }
  /**
  * @method confirmationSnack should displays confirmation
  */
  private confirmationSnack(data: string, classType: string): void {
    this.router.navigate(['dashboard/svpp/dashboard_content'], { queryParams: {}, skipLocationChange: true });
    this.openCommonSnack(data, classType);
  }
  /**
  * @method openCommonSnack will display noification bar based on data type
  */
  private openCommonSnack(dataType: string, classType: string): void {
    this.snackBar.openFromComponent(ConfirmationBarComponent, {
      data: { type: dataType },
      duration: 6000,
      verticalPosition: 'top',
      panelClass: ['custom-confirmation', classType],
    });
  }
  /**
   * @method errorResponse should call the spinner
   */
  private errorResponse(): void {
    this.router.navigate(['dashboard/svpp/dashboard_content'], { queryParams: {}, skipLocationChange: true });
    this.openCommonSnack('failed', 'failed');
  }
}
